module.exports = __webpack_public_path__ + "img/ap2020-watermark.f2f72cd.png";